// src/reducers/Reducer.js

import { combineReducers } from "redux";
import authReducer from "./authReducer";
import { msalReducer } from "../msalConfig";
import engagementReducer from './authReducer';

// Import the adminReducer
import adminReducer from './adminReducer';

import {
  REQUEST,
  SUCCESS,
  FAILURE,
  CREATE_QUICK_CHAT_REQUEST,
  CREATE_QUICK_CHAT_SUCCESS,
  CREATE_QUICK_CHAT_FAILURE,
  VIEWREQUEST,
  VIEWSUCCESS,
  VIEWFAILURE,
  DELETEREQUEST,
  DELETESUCCESS,
  DELETEFAILURE,
  ADD_REQUEST,
  ADD_SUCCESS,
  ADD_FAILURE,
  LIST_REQUEST,
  LIST_SUCCESS,
  LIST_FAILURE,
  DEL_REQUEST,
  DEL_SUCCESS,
  DEL_FAILURE,
  DOC_LIST_REQUEST,
  DOC_LIST_SUCCESS,
  DOC_LIST_FAILURE,
  DOC_USER_LIST_REQUEST,
  DOC_USER_LIST_SUCCESS,
  DOC_USER_LIST_FAILURE,
  DATASET_USER_LIST_REQUEST,
  DATASET_USER_LIST_SUCCESS,
  DATASET_USER_LIST_FAILURE,
  DATASET_USER_ADD_REQUEST,
  DATASET_USER_ADD_SUCCESS,
  DATASET_USER_ADD_FAILURE,
  DATASET_USER_DELETE_REQUEST,
  DATASET_USER_DELETE_SUCCESS,
  DATASET_USER_DELETE_FAILURE,
  LIST_RADIO_REQUEST,
  LIST_RADIO_SUCCESS,
  LIST_RADIO_FAILURE,
  LIST_CHAT_HISTORY_REQUEST,
  LIST_CHAT_HISTORY_SUCCESS,
  LIST_CHAT_HISTORY_FAILURE,
  LIST_CHAT_HISTORY_APPEND,
  ALL_CHAT_HISTORY_REQUEST,
  ALL_CHAT_HISTORY_SUCCESS,
  ALL_CHAT_HISTORY_FAILURE,
  ALL_CHAT_HISTORY_INVALIDATE,
  DEL_CHAT_HISTORY_REQUEST,
  DEL_CHAT_HISTORY_SUCCESS,
  DEL_CHAT_HISTORY_FAILURE,
  EDIT_CHAT_HISTORY_REQUEST,
  EDIT_CHAT_HISTORY_SUCCESS,
  EDIT_CHAT_HISTORY_FAILURE,
  CHAT_HISTORY_CONVERSATION_REQUEST,
  CHAT_HISTORY_CONVERSATION_RESET,
  CHAT_HISTORY_CONVERSATION_SUCCESS,
  CHAT_HISTORY_CONVERSATION_FAILURE,
  CHAT_HISTORY_FILTER_REQUEST,
  CHAT_HISTORY_FILTER_SUCCESS,
  CHAT_HISTORY_FILTER_FAILURE,
  CHAT_HISTORY_FILTER_APPEND,
  QNA_CHAT_REQUEST,
  QNA_CHAT_SUCCESS,
  QNA_CHAT_FAILURE,
  CREATE_CHAT_REQUEST,
  CREATE_CHAT_SUCCESS,
  CREATE_CHAT_FAILURE,
  SUCCESS_PDFS_REQUEST,
  SUCCESS_PDFS_SUCCESS,
  SUCCESS_PDFS_FAILURE,
  SUCCESS_CONVERSATION_REQUEST,
  SUCCESS_CONVERSATION_SUCCESS,
  SUCCESS_CONVERSATION_FAILURE,
  DATASET_ACCESS_REQUEST,
  DATASET_ACCESS_SUCCESS,
  DATASET_ACCESS_FAILURE,
  DATASET_APPROVED_REQUEST,
  DATASET_APPROVED_SUCCESS,
  DATASET_APPROVED_FAILURE,
  DOCUMENT_SUMMARIZATION_REQUEST,
  DOCUMENT_SUMMARIZATION_SUCCESS,
  DOCUMENT_SUMMARIZATION_FAILURE,
  DOWNLOAD_PDF_URL_REQUEST,
  DOWNLOAD_PDF_URL_SUCCESS,
  DOWNLOAD_PDF_URL_FAILURE,
  USERS_LIST_REQUEST,
  USERS_LIST_SUCCESS,
  USERS_LIST_FAILURE,
  ADD_USER_REQUEST,
  ADD_USER_SUCCESS,
  ADD_USER_FAILURE,
  DELETE_USER_REQUEST,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILURE,
  GET_USER_REQUEST,
  GET_USER_SUCCESS,
  GET_USER_FAILURE,
  DATASET_REQUEST_LIST,
  DATASET_REQUEST_LIST_SUCCESS,
  DATASET_REQUEST_LIST_FAILURE,
  DATASET_USER_REQUEST_LIST,
  DATASET_USER_REQUEST_LIST_SUCCESS,
  DATASET_USER_REQUEST_LIST_FAILURE,
  REQUEST_APPROVE_DATASET_LIST,
  REQUEST_APPROVE_DATASET_LIST_SUCCESS,
  REQUEST_APPROVE_DATASET_LIST_FAILURE,
  REQUEST_DENY_DATASET_LIST,
  REQUEST_DENY_DATASET_LIST_SUCCESS,
  REQUEST_DENY_DATASET_LIST_FAILURE,
  FEEDBACK_SERVICE_REQUEST,
  FEEDBACK_SERVICE_SUCCESS,
  FEEDBACK_SERVICE_FAILURE,
  feedbackServiceRequest,
  FEEDBACK_SUGGESTION_REQUEST,
  FEEDBACK_SUGGESTION_SUCCESS,
  FEEDBACK_SUGGESTION_FAILURE,
  GETCHAT_COUNT_REQUEST,
  GETCHAT_COUNT_SUCCESS,
  GETCHAT_COUNT_FAILURE,
  GETCHAT_STATUS_REQUEST,
  GETCHAT_STATUS_SUCCESS,
  GETCHAT_STATUS_FAILURE,
  TRAIN_REQUEST,
  TRAIN_SUCCESS,
  TRAIN_FAILURE,
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,
  SUMMARIZATION_DOC_URL_REQUEST,
  SUMMARIZATION_DOC_URL_SUCCESS,
  SUMMARIZATION_DOC_URL_FAILURE,
  EDIT_DATASET_REQUEST,
  EDIT_DATASET_SUCCESS,
  EDIT_DATASET_FAILURE,
  DATASET_OTHERS_REQUEST,
  DATASET_OTHERS_SUCCESS,
  DATASET_OTHERS_FAILURE,
  CREATE_PROMPT_REQUEST,
  CREATE_PROMPT_SUCCESS,
  CREATE_PROMPT_FAILURE,
  UPDATE_PROMPT_REQUEST,
  UPDATE_PROMPT_SUCCESS,
  UPDATE_PROMPT_FAILURE,
  GET_PARAMETERS_REQUEST, 
  GET_PARAMETERS_SUCCESS,
  GET_PARAMETERS_FAILURE,
  DELETE_PROMPT_REQUEST,
  DELETE_PROMPT_SUCCESS,
  DELETE_PROMPT_FAILURE,
  CREATE_DOC_SETTINGS_REQUEST,
  CREATE_DOC_SETTINGS_SUCCESS,
  CREATE_DOC_SETTINGS_FAILURE,
  FETCH_DOC_SETTINGS_REQUEST,
  FETCH_DOC_SETTINGS_SUCCESS,
  FETCH_DOC_SETTINGS_FAILURE,
  UPDATE_DOC_SETTINGS_REQUEST,
  UPDATE_DOC_SETTINGS_SUCCESS,
  UPDATE_DOC_SETTINGS_FAILURE,
  DELETE_PARAMETER_REQUEST,
  DELETE_PARAMETER_SUCCESS,
  DELETE_PARAMETER_FAILURE,
  ADD_ENGAGEMENT_REQUEST,
  ADD_ENGAGEMENT_SUCCESS,
  ADD_ENGAGEMENT_FAILURE,
  FETCH_ENGAGEMENT_REQUEST,
  FETCH_ENGAGEMENT_SUCCESS,
  FETCH_ENGAGEMENT_FAILURE,
  SAVE_INTEGRATION_REQUEST,
  SAVE_INTEGRATION_SUCCESS,
  SAVE_INTEGRATION_FAILURE,
  FETCH_SERVICE_NOW_INTEGRATION_REQUEST,
  FETCH_SERVICE_NOW_INTEGRATION_SUCCESS,
  FETCH_SERVICE_NOW_INTEGRATION_FAILURE,
  DELETE_SERVICE_NOW_INTEGRATION_REQUEST,
  DELETE_SERVICE_NOW_INTEGRATION_SUCCESS,
  DELETE_SERVICE_NOW_INTEGRATION_FAILURE,
  EMAIL_SUPPORT_REQUEST,
  EMAIL_SUPPORT_SUCCESS,
  EMAIL_SUPPORT_FAILURE,
  DELETE_EMAIL_SUPPORT_REQUEST,
  DELETE_EMAIL_SUPPORT_SUCCESS,
  DELETE_EMAIL_SUPPORT_FAILURE,
  GET_EMAIL_SUPPORT_REQUEST, 
  GET_EMAIL_SUPPORT_SUCCESS, 
  GET_EMAIL_SUPPORT_FAILURE ,


  CREATE_AGENT_REQUEST,
  CREATE_AGENT_SUCCESS,
  CREATE_AGENT_FAILURE,
  UPDATE_AGENT_STATUS_REQUEST,
  UPDATE_AGENT_STATUS_SUCCESS,
  UPDATE_AGENT_STATUS_FAILURE,
  GET_AGENT_STATUS_REQUEST,
  GET_AGENT_STATUS_SUCCESS,
  GET_AGENT_STATUS_FAILURE,
  CREATE_QNA_REQUEST,
  CREATE_QNA_SUCCESS,
  CREATE_QNA_FAILURE,
  GET_HUMAN_AGENT_QNA_REQUEST,
  GET_HUMAN_AGENT_QNA_SUCCESS,
  GET_HUMAN_AGENT_QNA_FAILURE,
  VALIDATE_AGENT_REQUEST,
  VALIDATE_AGENT_SUCCESS,
  VALIDATE_AGENT_FAILURE,
  SAVE_AGENT_EMAIL_REQUEST,
  SAVE_AGENT_EMAIL_SUCCESS,
  SAVE_AGENT_EMAIL_FAILURE,
  GET_AGENT_EMAIL_REQUEST,
  GET_AGENT_EMAIL_SUCCESS,
  GET_AGENT_EMAIL_FAILURE,
  DELETE_AGENT_EMAIL_REQUEST,
  DELETE_AGENT_EMAIL_SUCCESS,
  DELETE_AGENT_EMAIL_FAILURE,
  RESET_USER_QUESTION,
  RESET_AGENT_RESPONSE,
  RESET_AGENT_STATUS,
  RESET_QUESTION,
  RESET_ANSWER,
  FETCH_ASSISTANT_PARAMETERS_REQUEST,
  FETCH_ASSISTANT_PARAMETERS_SUCCESS,
  FETCH_ASSISTANT_PARAMETERS_FAILURE,
  SAVE_ASSISTANT_PARAMETERS_REQUEST,
  SAVE_ASSISTANT_PARAMETERS_SUCCESS,
  SAVE_ASSISTANT_PARAMETERS_FAILURE,
  UPDATE_ASSISTANT_PARAMETERS_REQUEST,
  UPDATE_ASSISTANT_PARAMETERS_SUCCESS,
  UPDATE_ASSISTANT_PARAMETERS_FAILURE,
  DELETE_ASSISTANT_SETTINGS_REQUEST,
  DELETE_ASSISTANT_SETTINGS_SUCCESS,
  DELETE_ASSISTANT_SETTINGS_FAILURE,
  FETCH_COMBINED_DATA_REQUEST,
  FETCH_COMBINED_DATA_SUCCESS,
  FETCH_COMBINED_DATA_FAILURE,
  SAVE_TOKEN_USAGE_REQUEST,
  SAVE_TOKEN_USAGE_SUCCESS,
  SAVE_TOKEN_USAGE_FAILURE,
  GET_TOKEN_USAGE_REQUEST,
  GET_TOKEN_USAGE_SUCCESS,
  GET_TOKEN_USAGE_FAILURE,
  GET_TOKEN_SUMMARY_REQUEST,
  GET_TOKEN_SUMMARY_SUCCESS,
  GET_TOKEN_SUMMARY_FAILURE,
  GET_TOKEN_DAILY_REQUEST,
  GET_TOKEN_DAILY_SUCCESS,
  GET_TOKEN_DAILY_FAILURE,
  GET_TOKEN_BY_MODEL_REQUEST,
  GET_TOKEN_BY_MODEL_SUCCESS,
  GET_TOKEN_BY_MODEL_FAILURE,
  GET_TOKEN_BY_USER_REQUEST,
  GET_TOKEN_BY_USER_SUCCESS,
  GET_TOKEN_BY_USER_FAILURE,
// agent will do just like below one
  FETCH_EXTERNAL_DATASET_REQUEST,
  FETCH_EXTERNAL_DATASET_SUCCESS,
  FETCH_EXTERNAL_DATASET_FAILURE,
  FETCH_INNFERRE_TOKEN_REQUEST,
  FETCH_INNFERRE_TOKEN_SUCCESS,
  FETCH_INNFERRE_TOKEN_FAILURE, 
} from "../actions/dataConsoleAction";

const initialEmailSupportState = {
  data: null,
  loading: false,
  error: null,
};

const emailSupportReducer = (state = initialEmailSupportState, action) => {
  switch (action.type) {
    case EMAIL_SUPPORT_REQUEST:
      return { ...state, loading: true, error: null };
    case EMAIL_SUPPORT_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case EMAIL_SUPPORT_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case DELETE_EMAIL_SUPPORT_REQUEST:
      return { ...state, loading: true };
    case DELETE_EMAIL_SUPPORT_SUCCESS:
      return { ...state, loading: false, data: null };
    case DELETE_EMAIL_SUPPORT_FAILURE:
      return { ...state, loading: false, error: action.payload };
      case GET_EMAIL_SUPPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_EMAIL_SUPPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case GET_EMAIL_SUPPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};


const initialDeleteParameterState = {
  deleteParameterData: [],
  loading: false,
  error: null,
  deleteParameterStatus: null,
};

const initialServiceNowState = {
  data: null,
  loading: false,
  error: null,
};


const serviceNowIntegrationReducer = (state = initialServiceNowState, action) => {
  switch (action.type) {
    case FETCH_SERVICE_NOW_INTEGRATION_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_SERVICE_NOW_INTEGRATION_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case FETCH_SERVICE_NOW_INTEGRATION_FAILURE:
      return { ...state, loading: false, error: action.payload };
      case DELETE_SERVICE_NOW_INTEGRATION_REQUEST:
      return { ...state, loading: true, error: null };

    case DELETE_SERVICE_NOW_INTEGRATION_SUCCESS:
      
      return { ...state, loading: false, data: null };

    case DELETE_SERVICE_NOW_INTEGRATION_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
const initialIntegrationState = {
  data: null,
  loading: false,
  error: null,
};



const integrationReducer = (state = initialIntegrationState, action) => {
  switch (action.type) {
    case SAVE_INTEGRATION_REQUEST:
      return { ...state, loading: true, error: null };
    case SAVE_INTEGRATION_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case SAVE_INTEGRATION_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};


const initialDeletePromptState = {
  deletePromptData: [],
  loading: false,
  error: null,
  deletePromptStatus: null,
};


const initialAddDocState = {
  addDocData: [],
  loading: false,
  error: null,
  addDocDataStatus: null,
};

const addDataSetInitialState = {
  addDataSetResponseData: [],
  loading: false,
  error: null,
  AddDatasetStatus: null,
};

const dataSetinitialState = {
  response: [],
  loadings: false,
  errors: null,
};

const deleteSetinitialState = {
  responseDelete: [],
  loadings: false,
  errors: null,
  responseDeleteStatus: null,
};

const dataSetinitialRadioState = {
  responseRadioDataList: [],
  loadings: false,
  errors: null,
  dataSetinitialRadioStateStatus: null,
};

const chatHistoryInitialState = {
  responseChatHistory: [],
  loadingsChatHistory: false,
  errorsChatHistory: null,
  chatHistoryStatus: null,
  chatHistoryPagination: null,
  loadingMoreChatHistory: false,
};

const initialParametersState = {
  parameters: [],
  loading: false,
  error: null,
};

const initialState = {
  loading: false,
  success: false,
  error: null,
  prompt: null,
};

const initialStarRatingState = {
  ratingData: {},
  loading: false,
  error: null,
};

const initialfetchState = {
  data: [], 
  loading: false,
  error: null,
};


const initialDocSettingsState = {
  docSettings: [],
  loading: false,
  error: null,
  UpdateDocSettingsStatus: null,
};

const initialEngagementState = {
  loading: false,
  data: null,
  error: null,
};

const initialGetEngagementState = {
  loading: false,
  engagement: null,
  error: null,
  engagementStatus: null,

};

const initialAssistantState = {
  parameters: null,
  loading: false,
  error: null,
  status: null,
};

const initialIsAssistantDatasetState = {
  isAssistantDataset: null, // Store only the isAssistantDataset value
};

export const isAssistantDatasetReducer = (state = initialIsAssistantDatasetState, action) => {
  switch (action.type) {
    case "SET_IS_ASSISTANT_DATASET":
      console.log("Reducer - SET_IS_ASSISTANT_DATASET action payload:", action.payload);
      return {
        ...state,
        isAssistantDataset: action.payload,
      };
    default:
      return state;
  }
};

const assistantParametersReducer = (state = initialAssistantState, action) => {
  switch (action.type) {
    case FETCH_ASSISTANT_PARAMETERS_REQUEST:
    case SAVE_ASSISTANT_PARAMETERS_REQUEST:
    case UPDATE_ASSISTANT_PARAMETERS_REQUEST:
      return { ...state, loading: true, error: null, status: null };

    case FETCH_ASSISTANT_PARAMETERS_SUCCESS:
    case SAVE_ASSISTANT_PARAMETERS_SUCCESS:
    case UPDATE_ASSISTANT_PARAMETERS_SUCCESS:
      return { ...state, loading: false, parameters: action.payload, status: action.payload.status };

    case FETCH_ASSISTANT_PARAMETERS_FAILURE:
    case SAVE_ASSISTANT_PARAMETERS_FAILURE:
    case UPDATE_ASSISTANT_PARAMETERS_FAILURE:
      return { ...state, loading: false, error: action.error, status: action.payload.status };

    case DELETE_ASSISTANT_SETTINGS_REQUEST:
      return { ...state, loading: true, error: null };

    case DELETE_ASSISTANT_SETTINGS_SUCCESS:
      return { ...state, loading: false, parameters: null };

    case DELETE_ASSISTANT_SETTINGS_FAILURE:
      return { ...state, loading: false, error: action.error };

    default:
      return state;
  }
};

const promptReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_PROMPT_REQUEST:
    case UPDATE_PROMPT_REQUEST:
      
      return { ...state, loading: true, success: false, error: null };
    case CREATE_PROMPT_SUCCESS:
    case UPDATE_PROMPT_SUCCESS:
      return { ...state, loading: false, success: true, prompt: action.payload };
    case CREATE_PROMPT_FAILURE:
    case UPDATE_PROMPT_FAILURE:
      return { ...state, loading: false, success: false, error: action.payload };
    default:
      return state;
  }
};

const parametersReducer = (state = initialParametersState, action) => {
  switch (action.type) {
    case GET_PARAMETERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_PARAMETERS_SUCCESS:
      return {
        ...state,
        loading: false,
        parameters: action.payload,
      };
    case GET_PARAMETERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

const deleteParameterReducer = (state = initialDeleteParameterState, action) => {
  switch (action.type) {
    case DELETE_PARAMETER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DELETE_PARAMETER_SUCCESS:
      return {
        ...state,
        loading: false,
        deleteParameterData: action.payload ? action.payload.data : [],
        deleteParameterStatus: action.payload ? action.payload.status : null,
      };
    case DELETE_PARAMETER_FAILURE:
      return {
        ...state,
        loading: false,
        deleteParameterData: [],
        error: action.error,
      };
    default:
      return state;
  }
};

const getEngagementReducer = (state = initialGetEngagementState, action) => {
  switch (action.type) {
    case FETCH_ENGAGEMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
      case FETCH_ENGAGEMENT_SUCCESS:
        const newState = {
          ...state,
          loading: false,
          engagement: action.payload,
          engagementStatus: action.payload.status,
        };
        return newState;
    case FETCH_ENGAGEMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};


const engagementtimeReducer = (state = initialEngagementState, action) => {
  switch (action.type) {
    case ADD_ENGAGEMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case ADD_ENGAGEMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case ADD_ENGAGEMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;}
  };

const docSettingsReducer = (state = initialfetchState, action) => {
  switch (action.type) {
    case CREATE_DOC_SETTINGS_REQUEST:
    case UPDATE_DOC_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case CREATE_DOC_SETTINGS_SUCCESS:
    case UPDATE_DOC_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        UpdateDocSettingsStatus: 200,
      };
    case CREATE_DOC_SETTINGS_FAILURE:
    case UPDATE_DOC_SETTINGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

const fetchdocSettingsReducer = (state = initialDocUserState, action) => {
  switch (action.type) {
    case FETCH_DOC_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_DOC_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        docSettings: action.payload ,
        UpdateDocSettingsStatus: action.payload.status,
      };
    case FETCH_DOC_SETTINGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
 

const deletePromptReducer = (state = initialDeletePromptState, action) => {
  switch (action.type) {
    case DELETE_PROMPT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DELETE_PROMPT_SUCCESS:
      return {
        ...state,
        loading: false,
        deletePromptData: action.payload ? action.payload.data : [],
        deletePromptStatus: action.payload ? action.payload.status : null,
      };
    case DELETE_PROMPT_FAILURE:
      return {
        ...state,
        loading: false,
        deletePromptData: [],
        error: action.error,
      };
    default:
      return state;
  }
};
const addDocReducer = (state = initialAddDocState, action) => {
  switch (action.type) {
    case REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case SUCCESS:
      return {
        ...state,
        loading: false,
        addDocData: action.payload.data,
        addDocDataStatus: action.payload.status,
      };
    case FAILURE:
      return {
        ...state,
        loading: false,
        addDocData: action.payload.data,
        addDocDataStatus: action.payload.status,
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialGetDocState = {
  docListData: [],
  loading: false,
  error: null,
  docListDataStatus: null,
};

const getDocReducer = (state = initialGetDocState, action) => {
  switch (action.type) {
    case DOC_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DOC_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        docListData: action.payload.data,
        docListDataStatus: action.payload.status,
      };
    case DOC_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        docListData: action.payload.data,
        docListDataStatus: action.payload.status,
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialDltFileState = {
  deleteData: [],
  loading: false,
  error: null,
  deleteDataStatus: null,
};

const dltFileReducer = (state = initialDltFileState, action) => {
  switch (action.type) {
    case DELETEREQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DELETESUCCESS:
      return {
        ...state,
        loading: false,
        deleteData: action.payload.data,
        deleteDataStatus: action.payload.status,
      };
    case DELETEFAILURE:
      return {
        ...state,
        loading: false,
        deleteData: action.payload.data,
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialViewFileState = {
  viewData: [],
  loading: false,
  error: null,
  viewDataStatus: null,
};

const viewFileReducer = (state = initialViewFileState, action) => {
  switch (action.type) {
    case VIEWREQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case VIEWSUCCESS:
      return {
        ...state,
        loading: false,
        viewData: action.payload.data,
        viewDataStatus: action.payload.status,
      };
    case VIEWFAILURE:
      return {
        ...state,
        loading: false,
        viewData: action.payload.data,
        error: action.payload,
      };
    default:
      return state;
  }
};

const addReducer = (state = addDataSetInitialState, action) => {
  switch (action.type) {
    case ADD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case ADD_SUCCESS:
      return {
        ...state,
        loading: false,
        addDataSetResponseData: action.payload.data,
        AddDatasetStatus: action.payload.status,
      };
    case ADD_FAILURE:
      return {
        ...state,
        loading: false,
        addDataSetResponseData: action.payload.data,
        error: action.payload,
      };
    default:
      return state;
  }
};

const listDatasetReducer = (state = dataSetinitialState, action) => {
  switch (action.type) {
    case LIST_REQUEST:
      return {
        ...state,
        loadings: true,
        errors: null,
      };
    case LIST_SUCCESS:
      return {
        ...state,
        loadings: false,
        response: action.payload.data,
      };
    case LIST_FAILURE:
      return {
        ...state,
        loadings: false,
        response: action.payload.data,
        errors: action.payload,
      };
    default:
      return state;
  }
};

const deleteDataSetReducer = (state = deleteSetinitialState, action) => {
  switch (action.type) {
    case DEL_REQUEST:
      return {
        ...state,
        loadings: true,
        errors: null,
      };
    case DEL_SUCCESS:
      return {
        ...state,
        loadings: false,
        responseDelete: action.payload.data,
        responseDeleteStatus: action.payload.status,
      };
    case DEL_FAILURE:
      return {
        ...state,
        loadings: false,
        responseDelete: action.payload.data,
        errors: action.payload.data,
      };
    default:
      return state;
  }
};

const initialDocUserState = {
  documentUserListData: [],
  loading: false,
  error: null,
};

const documentUserList = (state = initialDocUserState, action) => {
  switch (action.type) {
    case DOC_USER_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DOC_USER_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        documentUserListData: action.payload.data,
      };
    case DOC_USER_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        documentUserListData: action.payload.data,
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialDatasetUserState = {
  datasetUserListData: [],
  loading: false,
  error: null,
  datasetUserListDataStatus: null,
};

const datasetUserList = (state = initialDatasetUserState, action) => {
  switch (action.type) {
    case DATASET_USER_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DATASET_USER_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        datasetUserListData: action.payload.data,
        datasetUserListDataStatus: action.payload.status,
      };
    case DATASET_USER_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        datasetUserListData: action.payload.data,
        datasetUserListDataStatus: action.payload.status,
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialAddDatasetUserState = {
  datasetUserAddData: [],
  loading: false,
  error: null,
  addUserToDatasetStatus: null,
};

const AddDatasetUser = (state = initialAddDatasetUserState, action) => {
  switch (action.type) {
    case DATASET_USER_ADD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DATASET_USER_ADD_SUCCESS:
      return {
        ...state,
        loading: false,
        datasetUserAddData: action.payload,
        addUserToDatasetStatus: action.payload,
      };
    case DATASET_USER_ADD_FAILURE:
      return {
        ...state,
        loading: false,
        datasetUserAddData: action.payload,
        error: action.payload,
        addUserToDatasetStatus: action.payload,
      };
    default:
      return state;
  }
};

const initialDeleteDatasetUserState = {
  datasetUserDeleteData: [],
  loading: false,
  error: null,
};

const DeleteDatasetUser = (state = initialDeleteDatasetUserState, action) => {
  switch (action.type) {
    case DATASET_USER_DELETE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DATASET_USER_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        datasetUserDeleteData: action.payload,
      };
    case DATASET_USER_DELETE_FAILURE:
      return {
        ...state,
        loading: false,
        datasetUserDeleteData: action.payload,
        error: action.payload,
      };
    default:
      return state;
  }
};

const listDatasetRadioReducer = (state = dataSetinitialRadioState, action) => {
  switch (action.type) {
    case LIST_RADIO_REQUEST:
      return {
        ...state,
        loadings: true,
        errors: null,
      };
    case LIST_RADIO_SUCCESS:
      return {
        ...state,
        loadings: false,
        responseRadioDataList: action.payload.data,
        dataSetinitialRadioStateStatus: action.payload.status,
      };
    case LIST_RADIO_FAILURE:
      return {
        ...state,
        loadings: false,
        responseRadioDataList: action.payload,
        errors: action.payload,
      };
    default:
      return state;
  }
};

const chatHistoryRed = (state = chatHistoryInitialState, action) => {
  switch (action.type) {
    case LIST_CHAT_HISTORY_REQUEST:
      return {
        ...state,
        loadingsChatHistory: true,
        errorsChatHistory: null,
      };
    case LIST_CHAT_HISTORY_SUCCESS:
      return {
        ...state,
        loadingsChatHistory: false,
        responseChatHistory: action.payload.data?.data || action.payload.data,
        chatHistoryPagination: action.payload.data?.pagination || null,
        chatHistoryStatus: action.payload.status,
      };
    case LIST_CHAT_HISTORY_APPEND:
      return {
        ...state,
        loadingMoreChatHistory: false,
        responseChatHistory: [
          ...state.responseChatHistory,
          ...(action.payload.data?.data || action.payload.data),
        ],
        chatHistoryPagination: action.payload.data?.pagination || null,
        chatHistoryStatus: action.payload.status,
      };
    case LIST_CHAT_HISTORY_FAILURE:
      return {
        ...state,
        loadingsChatHistory: false,
        loadingMoreChatHistory: false,
        responseChatHistory: action.payload.data,
        errorsChatHistory: action.payload,
      };
    default:
      return state;
  }
};

// Cached all-chat-history (for dashboards)
const allChatHistoryInitialState = {
  data: [],
  loading: false,
  fetched: false,
  error: null,
};

const allChatHistoryRed = (state = allChatHistoryInitialState, action) => {
  switch (action.type) {
    case ALL_CHAT_HISTORY_REQUEST:
      return { ...state, loading: true, error: null };
    case ALL_CHAT_HISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        fetched: true,
        data: action.payload || [],
        error: null,
      };
    case ALL_CHAT_HISTORY_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case ALL_CHAT_HISTORY_INVALIDATE:
      return { ...allChatHistoryInitialState };
    default:
      return state;
  }
};

const deleteChatHistoryInitialState = {
  deleteChatHistoryResponseData: [],
  deleteChatHistoryStatus: null,
};
const initialChatHistoryConversation = {
  chatData: [],
  loading: false,
  error: null,
  chatDataStatus: null,
};

const deleteChatHistory = (state = deleteChatHistoryInitialState, action) => {
  switch (action.type) {
    case DEL_CHAT_HISTORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DEL_CHAT_HISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        deleteChatHistoryResponseData: action.payload.data,
        deleteChatHistoryStatus: action.payload.status,
      };
    case DEL_CHAT_HISTORY_FAILURE:
      return {
        ...state,
        loading: false,
        deleteChatHistoryResponseData: action.payload.data,
        deleteChatHistoryStatus: action.payload.status,
        error: action.payload,
      };
    default:
      return state;
  }
};

const editChatHistoryInitialState = {
  editData: [],
  loading: false,
  error: null,
  editDataStatus: null,
};

const editChatHistory = (state = editChatHistoryInitialState, action) => {
  switch (action.type) {
    case EDIT_CHAT_HISTORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case EDIT_CHAT_HISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        editData: action.payload.data,
        editDataStatus: action.payload.status,
      };
    case EDIT_CHAT_HISTORY_FAILURE:
      return {
        ...state,
        loading: false,
        editData: action.payload.data,
      };
    default:
      return state;
  }
};

const ChatHistoryConversation = (
  state = initialChatHistoryConversation,
  action
) => {
  switch (action.type) {
    case CHAT_HISTORY_CONVERSATION_REQUEST:
      return {
        ...state,
        chatData: [],
        loading: true,
        error: null,
        chatDataStatus: null,
      };
    case CHAT_HISTORY_CONVERSATION_SUCCESS:
      return {
        ...state,
        loading: false,
        chatData: action.payload.data,
        chatDataStatus: action.payload.status,
      };
    case CHAT_HISTORY_CONVERSATION_FAILURE:
      return {
        ...state,
        loading: false,
        chatData: action.payload.data,
        error: action.payload,
      };
    case CHAT_HISTORY_CONVERSATION_RESET:
      return initialChatHistoryConversation;
    default:
      return state;
  }
};

const chatHistoryFilterInitialState = {
  filterData: [],
  loading: false,
  error: null,
  filterDataStatus: null,
  filterPagination: null,
};
const qnaChatInitialState = {
  qnaData: [],
  loading: false,
  error: null,
  qnaDataStaus: null,
};

const chatHistoryFilterData = (
  state = chatHistoryFilterInitialState,
  action
) => {
  switch (action.type) {
    case CHAT_HISTORY_FILTER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case CHAT_HISTORY_FILTER_SUCCESS:
      return {
        ...state,
        filterData: action.payload.data?.data || action.payload.data,
        filterPagination: action.payload.data?.pagination || null,
        filterDataStatus: action.payload.status,
        loading: false,
        error: null,
      };
    case CHAT_HISTORY_FILTER_APPEND:
      return {
        ...state,
        filterData: [
          ...state.filterData,
          ...(action.payload.data?.data || action.payload.data),
        ],
        filterPagination: action.payload.data?.pagination || null,
        filterDataStatus: action.payload.status,
        loading: false,
        error: null,
      };
    case CHAT_HISTORY_FILTER_FAILURE:
      return {
        ...state,
        filterData: action.payload.data,
        error: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};

const qnaChatBot = (state = qnaChatInitialState, action) => {
  switch (action.type) {
    case QNA_CHAT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case QNA_CHAT_SUCCESS:
      return {
        ...state,
        loading: false,
        qnaData: action.payload.data,
        qnaDataStaus: action.payload.status,
      };
    case QNA_CHAT_FAILURE:
      return {
        ...state,
        loading: false,
        qnaData: null,
        qnaDataStaus: 500,
        error: action.payload,
      };
    default:
      return state;
  }
};

const qnaChatHistoryInitialState = {
  chatHistoryData: [],
  loading: false,
  error: null,
  registerChatStatus: null,
};

const qnaChatHistory = (state = qnaChatHistoryInitialState, action) => {
  switch (action.type) {
    case CREATE_CHAT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case CREATE_CHAT_SUCCESS:
      return {
        ...state,
        loading: false,
        chatHistoryData: action.payload.data,
        registerChatStatus: action.payload.status,
      };
    case CREATE_CHAT_FAILURE:
      return {
        ...state,
        loading: false,
        chatHistoryData: action.payload.data,
      };
    default:
      return state;
  }
};

const saveChatConversationInitialState = {
  successConversationData: [],
  loading: false,
  error: null,
  successConversationDataStatus: null,
};

const saveSuccessChatConversation = (
  state = saveChatConversationInitialState,
  action
) => {
  switch (action.type) {
    case SUCCESS_CONVERSATION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case SUCCESS_CONVERSATION_SUCCESS:
      return {
        ...state,
        loading: false,
        successConversationData: action.payload.data,
        successConversationDataStatus: action.payload.status,
      };
    case SUCCESS_CONVERSATION_FAILURE:
      return {
        ...state,
        loading: false,
        successConversationData: null,
        successConversationDataStatus: null,
        error: action.payload,
      };
    default:
      return state;
  }
};

const requestInitialState = {
  response: [],
  loadings: false,
  errors: null,
};

const requestDatasetReducer = (state = requestInitialState, action) => {
  switch (action.type) {
    case DATASET_ACCESS_REQUEST:
      return {
        ...state,
        loadings: true,
        errors: null,
      };
    case DATASET_ACCESS_SUCCESS:
      return {
        ...state,
        loadings: false,
        responseDataRequestList: action.payload.data,
        datasetRequestStatus: action.payload.status,
      };
    case DATASET_ACCESS_FAILURE:
      return {
        ...state,
        loadings: false,
        responseDataRequestList: action.payload.data,
        errors: action.payload.errors,
        datasetRequestStatus: action.payload.status,
      };
    default:
      return state;
  }
};

const approvedDatasetReducer = (
  state = approvedDatasetInitialState,
  action
) => {
  switch (action.type) {
    case DATASET_APPROVED_REQUEST:
      return {
        ...state,
        loadings: true,
        errors: null,
      };
    case DATASET_APPROVED_SUCCESS:
      return {
        ...state,
        loadings: false,
        response: action.payload.data,
        approvedDatasetStatus: action.payload.status,
      };
    case DATASET_APPROVED_FAILURE:
      return {
        ...state,
        loadings: false,
        response: action.payload.data,
        errors: action.payload,
        approvedDatasetStatus: action.payload.status,
      };
    default:
      return state;
  }
};

const documentSummarizationInitialState = {
  documentSummarizationData: [],
  loading: false,
  error: null,
  documentSummarizationStatus: null,
};

const documentSummarizationResponse = (
  state = documentSummarizationInitialState,
  action
) => {
  switch (action.type) {
    case DOCUMENT_SUMMARIZATION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DOCUMENT_SUMMARIZATION_SUCCESS:
      return {
        ...state,
        loading: false,
        documentSummarizationData: action.payload.data,
        documentSummarizationStatus: action.payload.status,
      };
    case DOCUMENT_SUMMARIZATION_FAILURE:
      return {
        ...state,
        loading: false,
        documentSummarizationData: action.payload.data,
        error: action.payload,
      };
    default:
      return state;
  }
};

const downloadPdfUrlInitialState = {
  downloadPdfUrlData: [],
  loading: false,
  error: null,
  downloadPdfUrlStatus: null,
};

const downloadPdfUrlResponse = (state = downloadPdfUrlInitialState, action) => {
  switch (action.type) {
    case DOWNLOAD_PDF_URL_REQUEST:
      return {
        ...state,
        
        loading: true,
        error: null,
      };
    case DOWNLOAD_PDF_URL_SUCCESS:
      return {
        ...state,
        loading: false,
        downloadPdfUrlData: action.payload.data,
        downloadPdfUrlStatus: action.payload.status,
      };
    case DOWNLOAD_PDF_URL_FAILURE:
      return {
        ...state,
        loading: false,
        downloadPdfUrlData: action.payload.data,
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialAllUsersState = {
  allUsersData: [],
  loading: false,
  error: null,
  allUsersDataStatus: null,
};

const allUsersList = (state = initialAllUsersState, action) => {
  switch (action.type) {
    case USERS_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case USERS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        allUsersData: action.payload.data,
        allUsersDataStatus: action.payload.status,
      };
    case USERS_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        allUsersData: action.payload.data,
        error: action.payload,
      };
    default:
      return state;
  }
};

const addUsersInitialState = {
  addUserData: [],
  loading: false,
  error: null,
  addUserStatus: null,
};

const addUserDataB2c = (state = addUsersInitialState, action) => {
  switch (action.type) {
    case ADD_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case ADD_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        addUserData: action.payload.data,
        addUserStatus: action.payload.status,
      };
    case ADD_USER_FAILURE:
      return {
        ...state,
        loading: false,
        addUserData: action.payload.data,
        error: action.payload,
      };
    default:
      return state;
  }
};

const deleteUsersInitialState = {
  deleteB2cUserData: [],
  loading: false,
  error: null,
  deleteUserStatus: null,
};

export const deleteB2cUser = (state = deleteUsersInitialState, action) => {
  switch (action.type) {
    case DELETE_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DELETE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        deleteB2cUserData: action.payload.data,
        deleteUserStatus: action.payload.status,
      };
    case DELETE_USER_FAILURE:
      return {
        ...state,
        loading: false,
        deleteB2cUserData: action.payload.data,
        error: action.payload,
      };
    default:
      return state;
  }
};

const getUserInitialState = {
  response:{},
  loading: false,
  error: null,
  getUserInitialStatus: null,
}

export const getUser =(state= getUserInitialState, action) => {
  switch (action.type) {
    case GET_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case GET_USER_SUCCESS:
      return{
        ...state,
        loading:false,
        response: {
          ...state.response,
          [action.payload.data.id]: action.payload.data.displayName, // Map ID to displayName
        },
        getUserInitialStatus: action.payload.status,
      }
    case GET_USER_FAILURE:
      return {
        ...state,
        loading: false,
        response: action.payload.data,
        error: action.payload.status,
      };
    default: 
      return state;
  }
}

const requestDatasetInitialState = {
  requestDatasetData: [],
  loading: false,
  error: null,
  requestDatasetStatus: null,
};

export const requestDatasetList = (
  state = requestDatasetInitialState,
  action
) => {
  switch (action.type) {
    case DATASET_REQUEST_LIST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DATASET_REQUEST_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        requestDatasetData: action.payload.data,
        requestDatasetStatus: action.payload.status,
      };
    case DATASET_REQUEST_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        requestDatasetData: action.payload.data,
        error: action.payload,
      };
    default:
      return state;
  }
};

const requestUserDatasetInitialState = {
  requestUserDatasetData: [],
  loading: false,
  error: null,
  requestUserDatasetStatus: null,
};

export const requestDatasetUserList = (
  state = requestUserDatasetInitialState,
  action
) => {
  switch (action.type) {
    case DATASET_USER_REQUEST_LIST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DATASET_USER_REQUEST_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        requestUserDatasetData: action.payload.data,
        requestUserDatasetStatus: action.payload.status,
      };
    case DATASET_USER_REQUEST_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        requestUserDatasetData: action.payload.data,
        error: action.payload,
      };
    default:
      return state;
  }
};

const approvedDatasetInitialState = {
  response: [],
  loading: false,
  error: null,
  approvedDatasetStatus: null,
};

export const approvedRequestDataset = (
  state = approvedDatasetInitialState,
  action
) => {
  switch (action.type) {
    case REQUEST_APPROVE_DATASET_LIST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case REQUEST_APPROVE_DATASET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        approvedDatasetData: action.payload.data,
        approvedDatasetStatus: action.payload.status,
      };
    case REQUEST_APPROVE_DATASET_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        approvedDatasetData: action.payload.data,
        error: action.payload,
      };
    default:
      return state;
  }
};

const deniedDatasetInitialState = {
  deniedDatasetData: [],
  loading: false,
  error: null,
  deniedDatasetStatus: null,
};

export const deniedRequestDataset = (
  state = deniedDatasetInitialState,
  action
) => {
  switch (action.type) {
    case REQUEST_DENY_DATASET_LIST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case REQUEST_DENY_DATASET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        deniedDatasetData: action.payload.data,
        deniedDatasetStatus: action.payload.status,
      };
    case REQUEST_DENY_DATASET_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        deniedDatasetData: action.payload.data,
        error: action.payload,
      };
    default:
      return state;
  }
};

const trainInitialState = {
  trainData: [],
  loading: false,
  error: null,
  trainStatus: null,
};

export const trainRequest = (state = trainInitialState, action) => {
  switch (action.type) {
    case TRAIN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case TRAIN_SUCCESS:
      return {
        ...state,
        loading: false,
        trainData: action.payload.data,
        trainStatus: action.payload.status,
      };
    case TRAIN_FAILURE:
      return {
        ...state,
        loading: false,
        trainData: action.payload.data,
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialUpdateUserState = {
  updateUserResponse: [],
  loading: false,
  error: null,
  updateUserStatus: null,
};

const updateUserReducer = (state = initialUpdateUserState, action) => {
  switch (action.type) {
    case UPDATE_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        updateUserResponse: action.payload.data,
        updateUserStatus: action.payload.status,
      };
    case UPDATE_USER_FAILURE:
      return {
        ...state,
        loading: false,
        updateUserResponse: action.payload.data,
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialChatStatusState = {
  chatStatusData: [],
  loading: false,
  error: null,
  chatLikeStatus: null,
};

export const chatStatusLikeDislike = (
  state = initialChatStatusState,
  action
) => {
  switch (action.type) {
    case GETCHAT_STATUS_REQUEST:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case GETCHAT_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        chatStatusData: action.payload.data,
        chatLikeStatus: action.payload.status,
      };
    case GETCHAT_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        chatStatusData: action.payload.data,
        chatLikeStatus: action.payload,
      };
    default:
      return state;
  }
};

const feedbackServiceInitialState = {
  feedbackInitialData: [],
  loading: false,
  error: null,
  feedbackServiceRequestStatus: null,
};

export const chatFeedbackService = (
  state = feedbackServiceInitialState,
  action
) => {
  switch (action.type) {
    case FEEDBACK_SERVICE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FEEDBACK_SERVICE_SUCCESS:
      return {
        ...state,
        loading: false,
        feedbackInitialData: action.payload.data,
        feedbackServiceRequestStatus: action.payload.status,
      };
    case FEEDBACK_SERVICE_FAILURE:
      return {
        ...state,
        loading: false,
        feedbackInitialData: action.payload.data,
      };
    default:
      return state;
  }
};
const initialSummaryDocUrlState = {
  summaryDocUrlData: [],
  loading: false,
  error: null,
  summaryDocUrlStatus: null,
};

export const saveSummaryDocUrl = (
  state = initialSummaryDocUrlState,
  action
) => {
  switch (action.type) {
    case SUMMARIZATION_DOC_URL_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case SUMMARIZATION_DOC_URL_SUCCESS:
      return {
        ...state,
        loading: false,
        summaryDocUrlData: action.payload.data,
        summaryDocUrlStatus: action.payload.status,
      };
    case SUMMARIZATION_DOC_URL_FAILURE:
      return {
        ...state,
        loading: false,
        summaryDocUrlData: action.payload.data,
        error: action.payload,
      };
    default:
      return state;
  }
};

const feedbackSuggestionInitialState = {
  suggestionData: [],
  loadingsSuggestion: false,
  errorsSuggestion: null,
  suggestionStatus: null,
};

export const feedbackSuggestionService = (
  state = feedbackSuggestionInitialState,
  action
) => {
  switch (action.type) {
    case FEEDBACK_SUGGESTION_REQUEST:
      return {
        ...state,
        loadingsSuggestion: true,
        errorsSuggestion: null,
      };
    case FEEDBACK_SUGGESTION_SUCCESS:
      return {
        ...state,
        loadingsSuggestion: false,
        suggestionData: action.payload.data,
        suggestionStatus: action.payload.status,
      };
    case FEEDBACK_SUGGESTION_FAILURE:
      return {
        ...state,
        loadingsSuggestion: false,
        suggestionData: action.payload.data,
        errorsSuggestion: action.payload,
      };
    default:
      return state;
  }
};

const initialChatCountState = {
  chatCountData: [],
  loading: false,
  error: null,
  chatCountStatus: null,
};

export const chatCountsLikeDislike = (
  state = initialChatCountState,
  action
) => {
  switch (action.type) {
    case GETCHAT_COUNT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GETCHAT_COUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        chatCountData: action.payload.data,
        chatCountStatus: action.payload.status,
      };
    case GETCHAT_COUNT_FAILURE:
      return {
        ...state,
        loading: false,
        chatCountData: action.payload.data,
        chatCountStatus: action.payload,
      };
    default:
      return state;
  }
};

const initialFetchCombinedDataState = {
  data: null,
  loading: false,
  error: null,
};

const fetchCombinedDataReducer = (state = initialFetchCombinedDataState, action) => {
  switch (action.type) {
    case FETCH_COMBINED_DATA_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_COMBINED_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case FETCH_COMBINED_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export { fetchCombinedDataReducer };

const editDatasetInitialState = {
  editDatasetResponse: [],
  loading: false,
  error: null,
  editDataSetStatus: null,
};

const editDataset = (state = editDatasetInitialState, action) => {
  switch (action.type) {
    case EDIT_DATASET_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case EDIT_DATASET_SUCCESS:
      return {
        ...state,
        loading: false,
        editDatasetResponse: action.payload.data,
        editDataSetStatus: action.payload.status,
      };
    case EDIT_DATASET_FAILURE:
      return {
        ...state,
        loading: false,
        editDatasetResponse: action.payload.data,
        editDataSetStatus: action.payload,
      };
    default:
      return state;
  }
};

const othersDatasetInitialState = {
  othersDatasetData: [],
  loading: false,
  error: null,
  othersDatasetStatus: null,
};

const OthersDatasetReducer = (state = othersDatasetInitialState, action) => {
  switch (action.type) {
    case DATASET_OTHERS_REQUEST:
      return {
        ...state,
        loadings: true,
        errors: null,
      };
    case DATASET_OTHERS_SUCCESS:
      return {
        ...state,
        loadings: false,
        othersDatasetData: action.payload.data,
        othersDatasetStatus: action.payload.status,
      };
    case DATASET_OTHERS_FAILURE:
      return {
        ...state,
        loadings: false,
        othersDatasetData: action.payload.data,
        errors: action.payload,
        othersDatasetStatus: action.payload.status,
      };
    default:
      return state;
  }
};

export const starRatingReducer = (state = initialStarRatingState, action) => {
  switch (action.type) {
    case 'FETCH_STAR_RATING_REQUEST':
      return {
        ...state,
        loading: true,
        error: null,
      };
    case 'FETCH_STAR_RATING_SUCCESS':
      return {
        ...state,
        loading: false,
        ratingData: {
          ...state.ratingData,
          [action.payload.chatId]: action.payload.ratingData,
        },
      };
    case 'FETCH_STAR_RATING_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case 'ADD_STAR_RATING_SUCCESS':
      return {
        ...state,
        ratingData: {
          ...state.ratingData,
          [action.payload.chatId]: action.payload.rating,
        },
      };
    default:
      return state;
  }
};

const initialCreateAgentState = {
  loading: false,
  agentData: [],
  error: null,
};

const createAgentReducer = (state = initialCreateAgentState, action) => {
  switch (action.type) {
    case CREATE_AGENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case CREATE_AGENT_SUCCESS:
      return {
        ...state,
        loading: false,
        agentData: action.payload.data,
      };
    case CREATE_AGENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialUpdateAgentStatusState = {
  loading: false,
  updateStatus: null,
  error: null,
};

const updateAgentStatusReducer = (state = initialUpdateAgentStatusState, action) => {
  switch (action.type) {
    case UPDATE_AGENT_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case UPDATE_AGENT_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        updateStatus: action.payload.data,
      };
    case UPDATE_AGENT_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

const initialGetAgentStatusState = {
  statusData:[],
  loading: false,
  error: null,
  agentStatus: null,
};

const getAgentStatusReducer = (state = initialGetAgentStatusState, action) => {
  switch (action.type) {
    case GET_AGENT_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_AGENT_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        statusData: action.payload.data,
        agentStatus: action.payload.data.status,
      };
    case GET_AGENT_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case RESET_AGENT_STATUS:
      return initialGetAgentStatusState;
    default:
      return state;
  }
};

const initialCreateHumanAgentQnaState = {
  loading: false,
  UserQuestion: null,
  AgentResponse:null,
  responseType:null,
  error: null,
};

const createHumanAgentQnaReducer = (state = initialCreateHumanAgentQnaState, action) => {
  switch (action.type) {
    case CREATE_QNA_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case CREATE_QNA_SUCCESS:
      if (action.payload.type === 'question') {
        return {
          ...state,
          loading: false,
          UserQuestion: action.payload.question,
          responseType: 'question',
        };
      } else if (action.payload.type === 'answer') {
        return {
          ...state,
          loading: false,
          AgentResponse: action.payload.answer,
          responseType: 'answer',
        };
      }
    case CREATE_QNA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case RESET_USER_QUESTION:
      return {
        ...state,
        UserQuestion: null,
      };
    case RESET_AGENT_RESPONSE:
      return {
        ...state,
        AgentResponse: null,
      };
    default:
      return state;
  }
};

const initialGetHumanAgentQnaState = {
  loading: false,
  humanAgentQnaData: [],
  type:null,
  question:null,
  answer:null,
  questionTimestamp: null,
  answerTimestamp: null,
  error: null,
};

const getHumanAgentQnaReducer = (state = initialGetHumanAgentQnaState, action) => {
  switch (action.type) {
    case GET_HUMAN_AGENT_QNA_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_HUMAN_AGENT_QNA_SUCCESS:
      if (action.payload.type === 'question') {
        return {
          ...state,
          loading: false,
          question: action.payload.question,
          questionTimestamp: action.payload.questionTimestamp || null,
          type: 'question',
        };
      } else if (action.payload.type === 'answer') {
        return {
          ...state,
          loading: false,
          answer: action.payload.answer,
          answerTimestamp: action.payload.answerTimestamp || null,
          type: 'answer',
        };
      }
    case GET_HUMAN_AGENT_QNA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case RESET_QUESTION:
      return {
        ...state,
        question: null,
      };
    case RESET_ANSWER:
      return {
        ...state,
        answer: null,
      }; 
    default:
      return state;
  }
};

const validateAgentInitialState = {
    successAgentValidation:null,
    agentValid: null,
}

const validateAgentReducer = (state = validateAgentInitialState, action) => {
  switch (action.type) {
    case VALIDATE_AGENT_REQUEST:
      return {
        ...state,      
        successAgentValidation:null,
        agentValid: null,
        };
    case VALIDATE_AGENT_SUCCESS:
      return {
        ...state,
          successAgentValidation:action.payload.success,
          agentValid: action.payload.valid,
      }
    case VALIDATE_AGENT_FAILURE:
      return {
        ...state,
          successAgentValidation:action.payload.success,
          agentValid: action.payload.valid,
      };
    default:
      return state;
  }
};

const saveAgentEmailInitialState = {
  agentEmailId:''
};

const saveAgentEmailReducer = (state = saveAgentEmailInitialState, action) => {
  switch (action.type) {
    case SAVE_AGENT_EMAIL_REQUEST:
      return {
        ...state,
        agentEmailId:'',
      };
    case SAVE_AGENT_EMAIL_SUCCESS:
      return {
        ...state,
        agentEmailId:action.payload.agentEmailId,
      };
    case SAVE_AGENT_EMAIL_FAILURE:
      return {
        ...state,
        agentEmailId:'',
      };
    default:
      return state;
}
};

const deleteAgentEmailInitialState = {
  success:null,
  message:'',
}

const deleteAgentEmailReducer = (state = deleteAgentEmailInitialState, action) => {
  switch (action.type) {
    case DELETE_AGENT_EMAIL_REQUEST:
      return {
        ...state,
        success:null,
        message:'',
      };
    case DELETE_AGENT_EMAIL_SUCCESS:
      return {
        ...state,
        success:action.payload.success,
        message:action.payload.message,
      };
    case DELETE_AGENT_EMAIL_FAILURE:
      return {
        ...state,
        success:null,
        message:'',
      };
    default:
      return state;
  }
}

const getAgentEmailInitialState = {
  successAgentEmail:null,
  AgentEmailId:'',
}

const getAgentEmailReducer = (state = getAgentEmailInitialState, action) => {
  switch (action.type) {
    case GET_AGENT_EMAIL_REQUEST:
      return {
        ...state,
        successAgentEmail:null,
        AgentEmailId:'',
      };
    case GET_AGENT_EMAIL_SUCCESS:
      return {
        ...state,
        successAgentEmail:action.payload.success,
        AgentEmailId:action.payload.data.agentEmailId,
      };
    case GET_AGENT_EMAIL_FAILURE:
      return {
        ...state,
        successAgentEmail:false,
        AgentEmailId:'',
      };
    default:
      return state;
  }
}

// Quick Chat Reducer
const quickChatReducer = (state = { loading: false, error: null, createdDataset: null }, action) => {
  switch (action.type) {
    case CREATE_QUICK_CHAT_REQUEST:
      return { ...state, loading: true, error: null };
    case CREATE_QUICK_CHAT_SUCCESS:
      return { ...state, loading: false, createdDataset: action.payload, error: null };
    case CREATE_QUICK_CHAT_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

// Groups Reducers
const groupsReducer = (state = { groupsData: [], groupsDataStatus: null, loading: false, error: null }, action) => {
  switch (action.type) {
    case "GET_GROUPS_REQUEST":
      return { ...state, loading: true, error: null };
    case "GET_GROUPS_SUCCESS":
      return {
        ...state,
        loading: false,
        groupsData: action.payload,
        groupsDataStatus: 200,
        error: null
      };
    case "GET_GROUPS_FAILURE":
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

const createGroupReducer = (state = { createGroupResponse: null, createGroupStatus: null, loading: false, error: null }, action) => {
  switch (action.type) {
    case "CREATE_GROUP_REQUEST":
      return { ...state, loading: true, error: null };
    case "CREATE_GROUP_SUCCESS":
      return {
        ...state,
        loading: false,
        createGroupResponse: action.payload,
        createGroupStatus: 200,
        error: null
      };
    case "CREATE_GROUP_FAILURE":
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

const updateGroupReducer = (state = { updateGroupResponse: null, updateGroupStatus: null, loading: false, error: null }, action) => {
  switch (action.type) {
    case "UPDATE_GROUP_REQUEST":
      return { ...state, loading: true, error: null };
    case "UPDATE_GROUP_SUCCESS":
      return {
        ...state,
        loading: false,
        updateGroupResponse: action.payload,
        updateGroupStatus: 200,
        error: null
      };
    case "UPDATE_GROUP_FAILURE":
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

const deleteGroupReducer = (state = { deleteGroupResponse: null, deleteGroupStatus: null, loading: false, error: null }, action) => {
  switch (action.type) {
    case "DELETE_GROUP_REQUEST":
      return { ...state, loading: true, error: null };
    case "DELETE_GROUP_SUCCESS":
      return {
        ...state,
        loading: false,
        deleteGroupResponse: action.payload,
        deleteGroupStatus: 200,
        error: null
      };
    case "DELETE_GROUP_FAILURE":
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

const groupUsersReducer = (state = { groupUsersData: [], groupUsersDataStatus: null, loading: false, error: null }, action) => {
  switch (action.type) {
    case "GET_GROUP_USERS_REQUEST":
      return { ...state, loading: true, error: null };
    case "GET_GROUP_USERS_SUCCESS":
      return {
        ...state,
        loading: false,
        groupUsersData: action.payload,
        groupUsersDataStatus: 200,
        error: null
      };
    case "GET_GROUP_USERS_FAILURE":
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

const externalDatasetReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_INNFERRE_TOKEN_REQUEST:
    case FETCH_EXTERNAL_DATASET_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_INNFERRE_TOKEN_SUCCESS:
      return { ...state, loading: false, token: action.payload };

    case FETCH_EXTERNAL_DATASET_SUCCESS:
      return { ...state, loading: false, dataset: action.payload };

    case FETCH_INNFERRE_TOKEN_FAILURE:
    case FETCH_EXTERNAL_DATASET_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

const tokenUsageReducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_TOKEN_USAGE_REQUEST:
    case GET_TOKEN_USAGE_REQUEST:
      return { ...state, loading: true, error: null };

    case SAVE_TOKEN_USAGE_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        success: true, 
        error: null,
        data: action.payload 
      };

    case GET_TOKEN_USAGE_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        success: true, 
        error: null,
        stats: action.payload,
        data: action.payload 
      };

    case SAVE_TOKEN_USAGE_FAILURE:
    case GET_TOKEN_USAGE_FAILURE:
      return { 
        ...state, 
        loading: false, 
        success: false, 
        error: action.payload 
      };

    default:
      return state;
  }
};

const tokenSummaryReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TOKEN_SUMMARY_REQUEST:
      return { ...state, loading: true, error: null };

    case GET_TOKEN_SUMMARY_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        success: true, 
        error: null,
        summary: action.payload.data,
        data: action.payload.data 
      };

    case GET_TOKEN_SUMMARY_FAILURE:
      return { 
        ...state, 
        loading: false, 
        success: false, 
        error: action.payload 
      };

    default:
      return state;
  }
};

const tokenDailyReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TOKEN_DAILY_REQUEST:
      return { ...state, loading: true, error: null };

    case GET_TOKEN_DAILY_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        success: true, 
        error: null,
        daily: action.payload.data,
        data: action.payload.data 
      };

    case GET_TOKEN_DAILY_FAILURE:
      return { 
        ...state, 
        loading: false, 
        success: false, 
        error: action.payload 
      };

    default:
      return state;
  }
};

const tokenByModelReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TOKEN_BY_MODEL_REQUEST:
      return { ...state, loading: true, error: null };

    case GET_TOKEN_BY_MODEL_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        success: true, 
        error: null,
        byModel: action.payload.data,
        data: action.payload.data 
      };

    case GET_TOKEN_BY_MODEL_FAILURE:
      return { 
        ...state, 
        loading: false, 
        success: false, 
        error: action.payload 
      };

    default:
      return state;
  }
};

const tokenByUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TOKEN_BY_USER_REQUEST:
      return { ...state, loading: true, error: null };

    case GET_TOKEN_BY_USER_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        success: true, 
        error: null,
        byUser: action.payload.data,
        data: action.payload.data 
      };

    case GET_TOKEN_BY_USER_FAILURE:
      return { 
        ...state, 
        loading: false, 
        success: false, 
        error: action.payload 
      };

    default:
      return state;
  }
};

// Combine reducers
const rootReducer = combineReducers({
  msal: msalReducer,
  auth: authReducer,
  addDocReducer: addDocReducer,
  getDocReducer: getDocReducer,
  dltFileReducer: dltFileReducer,
  viewFileReducer: viewFileReducer,
  addDatasetReducer: addReducer,
  getlistDatasetReducer: listDatasetReducer,
  getdeleteDataSetReducer: deleteDataSetReducer,
  documentUserList: documentUserList,
  datasetUserList: datasetUserList,
  AddDatasetUser: AddDatasetUser,
  DeleteDatasetUser: DeleteDatasetUser,
  listDatasetRadioReducer: listDatasetRadioReducer,
  chatHistoryRed: chatHistoryRed,
  allChatHistoryRed: allChatHistoryRed,
  deleteChatHistory: deleteChatHistory,
  editChatHistory: editChatHistory,
  ChatHistoryConversation: ChatHistoryConversation,
  chatHistoryFilterData: chatHistoryFilterData,
  qnaChatBot: qnaChatBot,
  qnaChatHistory: qnaChatHistory,
  saveSuccessChatConversation: saveSuccessChatConversation,
  requestDatasetReducer: requestDatasetReducer,
  getOthersDatasetReducer: OthersDatasetReducer,
  getDatasetApprovedReducer: approvedDatasetReducer,
  documentSummarizationResponse: documentSummarizationResponse,
  downloadPdfUrlResponse: downloadPdfUrlResponse,
  allUsersList: allUsersList,
  addUserDataB2c: addUserDataB2c,
  deleteB2cUser: deleteB2cUser,
  requestDatasetList: requestDatasetList,
  requestDatasetUserList: requestDatasetUserList,
  approvedRequestDataset: approvedRequestDataset,
  deniedRequestDataset: deniedRequestDataset,
  chatFeedbackService: chatFeedbackService,
  feedbackSuggestionService: feedbackSuggestionService,
  chatCountsLikeDislike: chatCountsLikeDislike,
  chatStatusLikeDislike: chatStatusLikeDislike,
  trainRequest: trainRequest,
  updateUserReducer: updateUserReducer,
  saveSummaryDocUrl: saveSummaryDocUrl,
  editDatasetReducer: editDataset,
  promptReducer: promptReducer,
  parameters:parametersReducer,
  deletePromptReducer: deletePromptReducer, // Add the new reducer here
  docSettingsReducer: docSettingsReducer,
  fetchdocSettings:fetchdocSettingsReducer,
  deleteParameterReducer: deletePromptReducer,
  admin: adminReducer,
  starRating: starRatingReducer,
  getUser: getUser,
  engagementtime: engagementtimeReducer,
  getEngagement:getEngagementReducer,
  engagement : engagementReducer,
  integration: integrationReducer,
  emailSupport: emailSupportReducer,
  serviceNowIntegration: serviceNowIntegrationReducer,
  createAgent: createAgentReducer,
  updateAgentStatus: updateAgentStatusReducer,
  getAgentStatus: getAgentStatusReducer,
  createHumanAgentQna: createHumanAgentQnaReducer,
  getHumanAgentQna: getHumanAgentQnaReducer,
  validateAgent: validateAgentReducer,
  saveAgentEmail: saveAgentEmailReducer,
  deleteAgentEmail: deleteAgentEmailReducer,
  getAgentEmail: getAgentEmailReducer,
  assistantParameters: assistantParametersReducer,
  isAssistantDataset: isAssistantDatasetReducer,
  fetchCombinedData: fetchCombinedDataReducer,
  quickChat: quickChatReducer,
  groupsReducer: groupsReducer,
  createGroupReducer: createGroupReducer,
  updateGroupReducer: updateGroupReducer,
  deleteGroupReducer: deleteGroupReducer,
  groupUsersReducer: groupUsersReducer,
  externalDataset: externalDatasetReducer,
  tokenUsage: tokenUsageReducer,
  tokenSummary: tokenSummaryReducer,
  tokenDaily: tokenDailyReducer,
  tokenByModel: tokenByModelReducer,
  tokenByUser: tokenByUserReducer,
});

export default rootReducer;
